module.exports = __webpack_public_path__ + "img/building-graph.1a3c7770.png";